<template>
  <v-container class="login-page">
    <div class="my-4 form-header text-xs-right">
      <div class="logo">
        <img draggable="false" :src="require('@/assets/soae.png')" alt="Logo" />
        <p>Comunicação</p>
      </div>
    </div>
    <v-layout justify-center align-center>
      <v-card width="500">
        <v-card-title>
          <p class="primary--text ma-0 py-2 form-title headline">
            Resetar senha
          </p>
        </v-card-title>
        <v-card-text v-show="enviado">
          <span style="color: #B71C22;">{{ text }}</span>
        </v-card-text>
        <v-form v-model="validate" ref="form">
          <v-card-text>
            <v-flex md12>
              <v-text-field
                v-model="email"
                type="email"
                label="Email"
                placeholder="example@gmail.com"
                required
                :rules="rules"
              ></v-text-field>
            </v-flex>
            <v-flex md6 class="mt-2">
              <v-btn
                @click="enviar"
                @keyup.enter="enviar"
                class="primary"
                :loading="loadBtn"
                >Enviar</v-btn
              >
            </v-flex>
          </v-card-text>
        </v-form>
      </v-card>
    </v-layout>
    <!-- <v-snackbar v-model="snackbar" :color="cor ? cor : ''">
      {{ text }}
      <v-btn color="primary" text @click="snackbar = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar> -->
  </v-container>
</template>

<script>
import { Password } from '../service'

export default {
  data() {
    return {
      validate: true,
      cor: '',
      snackbar: false,
      text: '',
      email: '',
      loadBtn: false,
      enviado: false,
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      rules: [
        v => !!v || 'Campo requerido.',
        v => /.+@.+/.test(v) || 'Email inválido.'
      ]
    }
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.loadBtn = true
        try {
          const res = await Password.enviar(this.email, {
            escola: this.escola
          })
          this.text = res.message
          this.enviado = true
        } catch (erro) {
          this.snackbar = true
          this.text =
            'Não conseguimos encontrar um usuário com esse endereço de email.'
          this.cor = 'red'
          this.loadBtn = false
        }
        this.loadBtn = false
      }
    }
  }
}
</script>

<style lang="stylus">
a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.form-header {
  text-align: center;
  max-width: 180px;
  margin: 0 auto;

  img {
    width: 55%;
    margin-bottom: 5px;
  }

  p {
    font-weight: bold;
    font-size: 14;
    color: #888;
    line-height: 0;
  }
}

.form-title {
  font-weight: bold;
}
</style>
